import { useCallback, useEffect, useRef } from 'react';
import { commonSlice } from 'src/store/commonPart/slice';
import { useDispatch } from 'react-redux';
import { getDOMElement } from 'src/utils/DOM';

type Props = {
  showSidebar: boolean;
  innerWidth: number;
  showMenu: boolean;
  hasMenuData: boolean;
};

export const useToggleClasses = ({ showSidebar, innerWidth, showMenu, hasMenuData }: Props) => {
  const dispatch = useDispatch();

  const initOpenRef = useRef(false);

  const changeInitOpen = useCallback((value: boolean) => {
    initOpenRef.current = value;
  }, []);

  const bodyElement = useRef<HTMLElement>(getDOMElement('body'));
  const innerBodyElement = useRef<{ body: HTMLElement | null; bodyWrapper: HTMLElement | null }>({
    body: getDOMElement('#body'),
    bodyWrapper: getDOMElement('#r-body-wrapper'),
  });

  /** set padding to the outer content */
  useEffect(() => {
    if (hasMenuData) {
      const className = 'padding-sidebar';

      if (initOpenRef.current) {
        if (showMenu) {
          innerBodyElement.current.body?.classList.add(className);
          innerBodyElement.current.bodyWrapper?.classList.add(className);
        } else {
          innerBodyElement.current.body?.classList.remove(className);
          innerBodyElement.current.bodyWrapper?.classList.remove(className);
        }
      } else if (getDOMElement('#body.padding-sidebar')) {
        innerBodyElement.current.body?.classList.remove(className);
        innerBodyElement.current.bodyWrapper?.classList.remove(className);
      }

      dispatch(commonSlice.actions.setSidebarIsOpen(showMenu));
    }
  }, [dispatch, showMenu, hasMenuData]);

  /** disable/enable the window scrolling for small sizes */
  useEffect(() => {
    const className = 'bodyScrollLocked';

    if (innerWidth > 1 && innerWidth < 1024) {
      bodyElement.current?.classList[showSidebar ? 'add' : 'remove'](className);
    } else if (!showSidebar && bodyElement.current?.classList.contains(className)) {
      bodyElement.current?.classList.remove(className);
    }
  }, [innerWidth, showSidebar]);

  return { changeInitOpen };
};
